<button [hidden]='!isScrollableForWindowSize' aria-label="Scroll Right" class="right-btn" (click)="moveRight()" #rightBtn>
    &RightAngleBracket;
</button>

<button [hidden]='!isScrollableForWindowSize' aria-label="Scroll Left" class="left-btn" (click)="moveLeft()" #leftBtn>
  &LeftAngleBracket;
</button>
